module.exports = __webpack_public_path__ + "static/M3-6bc0e3433db64eb5f279ecb54d7f15e5.jpg";